import { createContext, useContext } from 'react';
import { LoggerFactory } from '@antecipa/core/helpers/logger/LoggerFactory';
import { ILogger } from '@antecipa/core/models/logger/ILogger';

import { AuthApiService } from './auth-api.service';
import { NotificationApiService } from './notification-api.service';

type ServicesState = {
  logger: ILogger;
  authApiService: any;
  notificationApiService: any;
};

const initialValue: ServicesState = {
  logger: LoggerFactory.getInstance(),
  authApiService: AuthApiService(),
  notificationApiService: NotificationApiService(),
};

const ServicesStateContext = createContext<ServicesState | undefined>(
  undefined
);

function ServicesProvider({ children }) {
  return (
    <ServicesStateContext.Provider value={initialValue}>
      {children}
    </ServicesStateContext.Provider>
  );
}

function useServicesState() {
  const context = useContext(ServicesStateContext);
  if (context === undefined) {
    throw new Error('useServicesState must be used within a ServicesProvider');
  }
  return context;
}

export { ServicesProvider, useServicesState };
